import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CHARGING_CARD_ORDER_ROUTE, NEW_CLIENT_NEW_ADDRESS_ROUTE, NEW_CLIENT_ROUTE, SUPERSCHNELL_ROUTE } from '@mwe/constants';
import { Router } from '@angular/router';
import { getCompanyCorrelationFromCategory } from '@mwe/utils';
import { IPopupModelV2, ModalChild, Sparte } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EnvTranslateDirective } from '../directives/env-translate/env-translate.directive';
import { TranslateDirective } from '@ngx-translate/core';
import { ClickableProductsCardComponent } from '../cards/clickable-products-card/clickable-products-card.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'mwe-order-products-popup',
  // todo refactor CardWithIconAndButtonComponent to use BasicCard instead of profile-card.scss, use template from here for Refactoring
  // refactor this template with CardWithIconAndButtonComponent
  templateUrl: './order-products-popup.component.html',
  imports: [EnvTranslateDirective, TranslateDirective, ClickableProductsCardComponent, ModalComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderProductsPopupComponent implements ModalChild {
  private router = inject(Router);
  private activeModal = inject(NgbActiveModal);

  popupModel = signal<IPopupModelV2>(null);

  // is being passed by popupService
  loadedData: boolean;
  Sparte = Sparte;

  hasAllProducts = computed(() => this.loadedData);
  stromCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Strom));
  waermeCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Fernwaerme));
  internetCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Internet));
  emobilityCompany = computed(() => getCompanyCorrelationFromCategory(Sparte.Emobility));

  startNewClientProcess(): void {
    this.closePopup();
    this.router.navigateByUrl(`/${NEW_CLIENT_ROUTE}/${NEW_CLIENT_NEW_ADDRESS_ROUTE}`);
  }

  startSuperSchnellProcess(): void {
    this.closePopup();
    this.router.navigateByUrl(`/${SUPERSCHNELL_ROUTE}/${NEW_CLIENT_NEW_ADDRESS_ROUTE}`);
  }

  orderChargingCard(): void {
    this.closePopup();
    this.router.navigateByUrl(`/${CHARGING_CARD_ORDER_ROUTE}`);
  }

  closePopup() {
    this.activeModal.close();
  }
}
